export default __webpack_public_path__ + "static/media/coworking.e6b44f44.jpg";